import { render } from "./WelcomeLogin.vue?vue&type=template&id=aece0f44"
import script from "./WelcomeLogin.vue?vue&type=script&lang=js"
export * from "./WelcomeLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__